import * as React from 'react';
import { useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import AddressSelection from '../../../../shared/containers/AddressSelection';
import { RootState } from '../../../../shared/store/reducers';
import Widget from '../Widget';
import { APP_ENV } from '../../../../shared/config/constants';
import { CALENDAR_CURRENT_MONTH_SEARCH_PARAM, CALENDAR_VIEW_SEARCH_PARAM, SENTRY_DSN } from '../../config/constants';

if (APP_ENV !== 'development' && APP_ENV !== 'ci') {
  Sentry.init({
    dsn: String(SENTRY_DSN),
    integrations: [new Integrations.BrowserTracing()],
    attachStacktrace: true,
    tracesSampleRate: 1.0,
    environment: APP_ENV,
    allowUrls: [/^https?:\/\/[^/]+\/libraries\/hvc_widgets\//],
  });
}

const WasteCalendar = () => {
  const address = useSelector((state: RootState) => state.geolocation.selected);

  const onAddressReset = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete(CALENDAR_VIEW_SEARCH_PARAM);
    url.searchParams.delete(CALENDAR_CURRENT_MONTH_SEARCH_PARAM);
    window.history.replaceState({}, '', url.toString());
  };

  return (
    <>
      <div className="u-indent--large">
        <AddressSelection onAddressReset={onAddressReset} />
      </div>
      {address && (
        <Widget address={address} />
      )}
    </>
  );
};

export default WasteCalendar;
